import type { WeddingSettings } from '@shared/settings'
import { tieneTexto } from './comunes'

/* ===========================================================================
   El programa del día — la lógica, no la pantalla.

   El itinerario dejó de vivir dentro de la invitación: con dieciocho momentos
   medía 1445 px de los 6870 de la página en un teléfono, y había que
   recorrerlo entero para llegar a lo de abajo. Ahora se pinta en
   `routes/publica/PaginaPrograma.tsx`, y aquí queda lo que comparten esa
   pantalla y la invitación: si hay programa, y qué momento está en curso.
   =========================================================================== */

export type Momento = WeddingSettings['schedule'][number]

export function hayPrograma(schedule: WeddingSettings['schedule']): boolean {
  return schedule.some((momento) => tieneTexto(momento.title))
}

/** Minutos desde medianoche si el texto trae un HH:MM; null si es hora libre. */
export function minutosDe(time: string): number | null {
  const partes = /(\d{1,2}):(\d{2})/.exec(time)
  if (!partes) return null
  const horas = Number(partes[1])
  const minutos = Number(partes[2])
  if (!Number.isFinite(horas) || !Number.isFinite(minutos)) return null
  if (horas > 23 || minutos > 59) return null
  return horas * 60 + minutos
}

/**
 * El momento vigente: el último cuya hora ya llegó, según el reloj local del
 * invitado. -1 si ninguna hora parsea o si todas están por venir.
 */
export function indiceVigente(momentos: Momento[], ahora: Date): number {
  const transcurrido = ahora.getHours() * 60 + ahora.getMinutes()
  let vigente = -1
  momentos.forEach((momento, i) => {
    const inicio = minutosDe(momento.time)
    if (inicio !== null && inicio <= transcurrido) vigente = i
  })
  return vigente
}
